module.exports = __webpack_public_path__ + "static/media/complete.6ea7c23d.svg";